import Section from "../section";
import NonAlcoholic from "./beverages/nonalcoholic";
import Bar from "./beverages/bar";

class Beverages extends Section {

  constructor(calculator) {
    super(calculator);

    this.bar = new Bar(this);

    this.parts = [
        new NonAlcoholic(this),
        this.bar,
      ];

    // 20% service fee for all food and beverage
    this.fee = 0.2;
  }

}

export default Beverages




// WEBPACK FOOTER //
// ./scripts/catcalc/sections/beverages.js